<template>
  <div>
    <div class="m-subheader">
      <div class="mr-subheader-box">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <span class="subheader-icon">
              <i class="m-menu__link-icon flaticon-line-graph"></i>
            </span>
            <h3 class="m-subheader__title">Fatura Yükle</h3>
          </div>
          <div>
           
          </div>
        </div>
      </div>
    </div>

    <div class="m-content">
      <div class="row">
        <div class="col-lg-12">
          <!--begin::Portlet-->
          <div class="m-portlet">
            <div class="m-portlet__head">
              <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                  <span class="m-portlet__head-icon m--hide">
                    <i class="la la-gear"></i>
                  </span>
                  <h3 class="m-portlet__head-text">
                    <a
                      :href="'#/'"
                      class="btn btn-sm btn-secondary m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill m--margin-right-10"
                    >
                      <i class="la la-angle-left"></i>
                    </a>
                    Fatura Dosyası Yükle
                  </h3>
                </div>
              </div>
            </div>

            <!--begin::Form-->
            <form class="m-form m-form--fit m-form--label-align-right">
              <div class="m-portlet__body m-form-box-cont">
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Dosya (excel)</label>
                    <input type="file"  :class="{ 'is-invalid': $v.files.$error }" v-on:change="fileChange($event.target.files)" class="form-control m-input" placeholder="csv seçiniz" />
                  </div>
                </div>
              </div>
              <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                <div class="m-form__actions m-form__actions--solid">
                  <div class="row">
                    <div class="col-lg-12">
                      <button type="button" multiple="false" @click="create()" class="spbtn">Yükle</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>

            <!--end::Form-->
          </div>

          <!--end::Portlet-->
        </div>
      </div>
    </div>
  </div>
</template>

<style>

</style>

<script>
import { required, email, minLength } from "vuelidate/lib/validators";
import {_uploadFile} from '../../services/InvoiceService';

export default {
  data() {
    return {
        files:new FormData()
    }
  },
    validations: {
      files: { required },
  },
methods: {
  create:function(){
          this.$v.files.$touch();
      if (this.$v.files.$error) return;
    _uploadFile(this.files).then(response=>{
      if(response.data.success)
        this.$router.push({ name: 'invoiceQueue' })
    });
  }
  , fileChange(fileList) {
            for (let i = 0; i < fileList.length; i++) {
                this.files.append("file", fileList[i],fileList[0].name);
            }
        }
},
};
</script>